import { render, staticRenderFns } from "./Repository.vue?vue&type=template&id=4b3de5c0&scoped=true&"
import script from "./Repository.vue?vue&type=script&lang=js&"
export * from "./Repository.vue?vue&type=script&lang=js&"
import style0 from "./Repository.vue?vue&type=style&index=0&id=4b3de5c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3de5c0",
  null
  
)

export default component.exports